module.exports = __webpack_public_path__ + "img/b3.fe6ca4c4.jpg";